import * as Models from 'contracts/models';

export const Endpoint = () => `/api/v3/useraction/organization_users/`;
export const QueryKey = () => ['v3', 'useraction', 'organization_users'] as const;
export type Payload = never;
export type Response = {
    users: Models.UserInfo.OrganizationUser[];
    organization: Models.UserInfo.Organization;
};
